import React from 'react';
import ReactDOM from 'react-dom';
import { Loader2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ResultConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ResultConfirmModal: React.FC<ResultConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[100]"
      data-result-confirm-modal="true"
    >
      <div className="bg-card border border-casino-border p-5 rounded-lg shadow-navy-shadow w-[95%] max-w-md">
        <div className="flex justify-between gap-x-2">
          <h2 className="font-semibold text-lg mb-2 text-white">Confirm Result</h2>
          <button onClick={onClose} className="self-start bg-white/10 hover:bg-white/20 rounded-full p-1 shadow">
            <X size={18} className="text-primary-golden" />
          </button>
        </div>

        <div className="text-sm text-white/70 space-y-3">
          <p className="font-medium text-white">
            The match may still be ongoing, and the final result is not yet confirmed.
          </p>
          <p>
            Declaring it prematurely could lead to incorrect settlements and potential financial
            loss.
          </p>
          <p>It is recommended to wait for official confirmation before proceeding.</p>
        </div>

        <div className="flex justify-end gap-2 mt-5">
          <Button type="button" variant="destructive" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="button"
            className="text-primary-foreground font-semibold bg-btn-gradient w-[100px] "
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center gap-x-2">
                <span className="inline-block animate-spin">
                  <Loader2 className="w-5" />
                </span>
                Saving...
              </div>
            ) : (
              'Proceed'
            )}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ResultConfirmModal;
